import { AbstractControl, ValidatorFn } from '@angular/forms';


export class FileValidators {

  /**
   * Validates that the number of selected files does not exceed the given count.
   * @param maxCount - The maximum number of files that can be selected.
   * @returns {ValidatorFn}
   */
  static maxFiles(maxCount = 1): ValidatorFn {
    return (control: AbstractControl<File | File[]>) => {
      if (!control.value || (Array.isArray(control.value) && control.value.length > maxCount)) {
        const count = Array.isArray(control.value) ? control.value.length : 1;
        return { maxFiles: { maxCount, actualCount: count } };
      }

      return null;
    };
  }

  /**
   * Validates that the number of selected files is at least the given count.
   * @param minCount - The minimum number of files that must be selected.
   * @returns {ValidatorFn}
   */
  static minFiles(minCount = 1): ValidatorFn {
    return (control: AbstractControl<File | File[]>) => {
      if (!control.value || (Array.isArray(control.value) && control.value.length < minCount)) {
        const count = Array.isArray(control.value) ? control.value.length : 1;
        return { minFiles: { minCount, actualCount: count } };
      }

      return null;
    };
  }

  /**
   * Validates that the size of the selected file does not exceed the given size.
   * @param maxSize - The maximum size of the file in bytes.
   * @returns {ValidatorFn}
   */
  static maxFileSize(maxSize: number): ValidatorFn {
    return (control: AbstractControl<File | File[]>) => {
      if (!control.value || (Array.isArray(control.value) && control.value.length === 0)) {
        return null;
      }

      const files = Array.isArray(control.value) ? control.value : [control.value];
      const tooLarge = files.some(file => file.size > maxSize);

      if (tooLarge) {
        return { maxFileSize: { maxSize } };
      }

      return null;
    };
  }
}
